'use strict';

import { Form } from '@lf/mwuikit/src/scripts/objects/form';
import { generateRecaptcha } from '../../api/reCaptchaForm';

(function () {
    const formElements = document.getElementsByClassName('form__recaptcha');

    for (let i = 0; i < formElements.length; i++) {
        const form = Form({ element: formElements[i], useDefaultSubmit: true });
        generateRecaptcha(formElements[i], () => formElements[i].submit());
    }
}());